if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";
        
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleButtonLoading(true);

        // Get the product ID from the form
        const productId = this.form
          .querySelector('input[name="id"]')
          .getAttribute("data-product-id");

        try {
          // Fetch current cart contents
          const cartResponse = await fetch("/cart.js");
          const cart = await cartResponse.json();

          // Check if product already exists in cart
          const isProductInCart = cart.items.some(
            (item) => item.product_id === parseInt(productId)
          );

          if (isProductInCart) {
            showNotice(cardDupeTitle, cardDupeMessage, "error");
            this.handleButtonLoading(false);
            return;
          }

          // Product not in cart - proceed with normal add to cart
          const formData = new FormData(this.form);
          const cartAddUrl = this.form.action || "/cart/add";

          // Log the form data for debugging
          for (let [key, value] of formData.entries()) {
            // console.log(`${key}: ${value}`);
          }

          const response = await fetch(cartAddUrl, {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            },
            body: formData,
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          this.handleButtonLoading(false);

          if (!this.cart) {
            window.location = "/cart";
            return;
          }

          window.location = "/cart";
        } catch (error) {
          console.error("Error:", error);
          this.handleErrorMessage(error.message);
          this.handleButtonLoading(false);
        }
      }

      handleButtonLoading(isLoading) {
        this.submitButton.classList.toggle("loading", isLoading);
        this.submitButton.setAttribute("aria-disabled", isLoading);
      }

      handleErrorMessage(errorMessage) {
        console.error("Error:", errorMessage);
        alert(`Failed to add product to cart: ${errorMessage}`);
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }
  );
}
class CustomSelect extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector("select");
    this.customSelectWrapper = null;
    this.customSelectTrigger = null;
    this.customOptions = null;
  }

  connectedCallback() {
    this.initCustomSelect();
    this.bindEvents();
  }

  initCustomSelect() {
    const select = this.select;
    const classes = select.getAttribute("class");

    let template = `<div class="custom-select ${classes}">`;
    template += `<span class="custom-select-trigger m-value">${
      select.options[select.selectedIndex].text
    }</span>`;
    template += '<div class="custom-options">';

    Array.from(select.options).forEach((option) => {
      template += `
        <span class="custom-option ${option.className}" 
              data-value="${option.value}">
          ${option.innerHTML}
        </span>`;
    });

    template += "</div></div>";

    const wrapper = document.createElement("div");
    wrapper.className = "custom-select-wrapper";
    this.insertBefore(wrapper, select);
    wrapper.appendChild(select);

    wrapper.insertAdjacentHTML("beforeend", template);

    this.customSelectWrapper = wrapper;
    this.customSelectTrigger = wrapper.querySelector(".custom-select-trigger");
    this.customOptions = wrapper.querySelector(".custom-options");
  }

  bindEvents() {
    this.customSelectTrigger.addEventListener(
      "click",
      this.toggleSelect.bind(this)
    );

    this.customOptions.querySelectorAll(".custom-option").forEach((option) => {
      option.addEventListener("click", this.selectOption.bind(this));
    });

    // Close custom select on click outside
    document.addEventListener("click", (event) => {
      if (!this.contains(event.target)) {
        this.customSelectWrapper
          .querySelector(".custom-select")
          .classList.remove("opened");
      }
    });
  }

  toggleSelect(event) {
    event.stopPropagation();
    this.customSelectWrapper
      .querySelector(".custom-select")
      .classList.toggle("opened");
  }

  selectOption(event) {
    const option = event.target;
    const value = option.getAttribute("data-value");

    this.select.value = value;

    this.customOptions.querySelectorAll(".custom-option").forEach((opt) => {
      opt.classList.remove("selection");
    });
    option.classList.add("selection");

    this.customSelectWrapper
      .querySelector(".custom-select")
      .classList.remove("opened");
    this.customSelectTrigger.textContent = option.textContent;

    const changeEvent = new Event("change", { bubbles: true });
    this.select.dispatchEvent(changeEvent);
  }
}

customElements.define("custom-select", CustomSelect);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.updateOptions();
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    this.variantId = variantId;
    this.selectBestAvailableVariant();
    this.updateMasterId();
  }
  selectBestAvailableVariant() {
    let selects = this.querySelectorAll('select');
    selects = Array.from(selects).filter(select => !select.classList.contains('bundle'));
    if (!selects.length) return;

    const primarySelect = selects[0];
    const options = primarySelect.querySelectorAll('option');
    let bestCloseDate = 0;
    let bestOption = null;
    const currentTimestamp = Math.floor(Date.now() / 1000);
    let validVariantIds = [];
    let bestVariantId = null;
    for (const option of options) {
      const closeDate = parseInt(option.getAttribute('close-date')) || 9999999999999999999;
      const today = parseInt(option.getAttribute('today')) || currentTimestamp;
      if (option.textContent.trim() === 'Unavailable' || (closeDate > 0 && today >= closeDate)) {
        continue;
      }
      let currentTitle = option.textContent.trim();
      const variant = this.getVariantData();
      const variantId = variant.find((variant) => {
        return variant.title === currentTitle;
      });

      if(today < closeDate) {
        validVariantIds.push(variantId.id);
      }

      if (!isNaN(closeDate) && (bestCloseDate == 0 ||
          (bestCloseDate > closeDate))) {
        bestOption = option;
        bestCloseDate = closeDate;
        bestVariantId = variantId.id;
      }
    }

    if (bestOption && (!this.variantId || !validVariantIds.includes(parseInt(this.variantId)))) {
      primarySelect.value = bestOption.value;
      this.updateOptions();
      this.updateMasterId();
      let htmlSelect = primarySelect.nextElementSibling.querySelector(`.custom-option[data-value="${bestOption.value}"]`);
      if (htmlSelect) {
        htmlSelect.click();
      }
      const changeEvent = new Event('change', { bubbles: true });
      primarySelect.dispatchEvent(changeEvent);
    }
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery?.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    // Preserves existing query parameters while updating the variant
    const url = new URL(window.location.href);
    url.searchParams.set("variant", this.currentVariant.id);
    window.history.replaceState({}, "", url.toString());
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    let productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    if (!productForms.length > 0) {
      productForms = document.querySelectorAll(`form#${this.dataset.formId}`);
      let noticeId = this.dataset.formId.replace("bundle-form-id", "course-notice-");
      let notice = document.getElementById(noticeId);
      // set notice html to "AI Product Manager <div class="text-small">Choose your start date below</div>
      let noticeHtml = this.currentVariant.name.replace(` - ${this.currentVariant.title}`, '') + " <div class='text-small'>"+this.currentVariant.title+"</div>";
      if (notice && this.currentVariant) {
        notice.innerHTML = noticeHtml;
      }
    }
    productForms.forEach((productForm) => {
      let input = productForm.querySelector('input[name="id"]');
      if (!input) {
        const newinput = document.createElement("input");
        newinput.type = "hidden";
        newinput.name = "id";
        newinput.classList.add("product-variant-id");
        productForm.appendChild(newinput);
        input = productForm.querySelector('input[name="id"]');
      }
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;
  }

  renderProductInfo() {
    fetch(
      `?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(!this.currentVariant.available, "Sold Out");

        //update course notice
        const courseNotice = document.getElementById(
          `course-notice-product-form-${this.dataset.section}`
        );
        const courseNoticeSource = html.getElementById(
          `course-notice-product-form-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (courseNoticeSource && courseNotice)
          courseNotice.innerHTML = courseNoticeSource.innerHTML;
        if (courseNoticeSource && !courseNotice.innerHTML) {
          courseNotice.classList.add("visibility-hidden");
        }
        //update product-cta-form
        this.updateProductCtaForm(html);
      });
  }

  updateProductCtaForm(html) {
    const productCtaForm = document.getElementById(
      `product-cta-form`
    );
    const productCtaFormDesktop = document.getElementById(
      `product-cta-form-desktop`
    );
    productCtaForm.innerHTML = html.getElementById(
      `product-cta-form`
    ).innerHTML;
    productCtaFormDesktop.innerHTML = html.getElementById(
      `product-cta-form-desktop`
    ).innerHTML;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const get_started_text = "Get started"
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = get_started_text;
    }
    if (addButton.hasAttribute("data-purchased")) {
      addButton.setAttribute("disabled", "disabled");
      addButtonText.textContent = 'Already purchased';
      return;
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);
